export default {
      id: "add-usage",
      viewBox: "0 0 10 10",
      url: __webpack_public_path__ + "sprite-46b249.svg#add-usage",
      toString: function () {
        return this.url;
      }
    }